/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConnectionstatusEnum } from './connectionstatusEnum';
import { DirectionOfConnectionEnum } from './directionOfConnectionEnum';


export interface SmppBindLog { 
    id: string;
    bindAddress?: string;
    port?: string;
    systemId?: string;
    password?: string;
    connectionStatus: ConnectionstatusEnum;
    connectionStatusName?: string;
    directionOfConnection: DirectionOfConnectionEnum;
    directionOfConnectionName?: string;
    dateOfBind: Date;
    name?: string;
    message?: string;
}
